export enum DepositAmountTypeEnum {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}

export const depositAmountTypeEnumMapping: Record<DepositAmountTypeEnum, string> = {
  [DepositAmountTypeEnum.AMOUNT]: 'Montant fixe',
  [DepositAmountTypeEnum.PERCENTAGE]: 'Pourcentage'
}
